import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=4f6a9572&"
import script from "./SettingsMenu.vue?vue&type=script&lang=ts&"
export * from "./SettingsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports